import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { usePlanAccess } from '@/hooks/usePlanAccess';
import type { PlanFeature } from '@/hooks/planAccess';

interface PlanGuardProps {
  feature: PlanFeature;
  children: React.ReactNode;
  fallbackPath?: string;
}

export default function PlanGuard({ feature, children, fallbackPath = '/subscription' }: PlanGuardProps) {
  const { loading, user, profile } = useAuth();
  const { hasFeature, isAdmin, trialExpired } = usePlanAccess();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="w-8 h-8 border-2 border-primary-500/30 border-t-primary-500 rounded-full animate-spin" />
      </div>
    );
  }

  // Admin always passes
  if (isAdmin) return <>{children}</>;

  // Trial expired? Force subscription page
  if (trialExpired) {
    return <Navigate to={fallbackPath} replace />;
  }

  // Check plan feature access
  if (!hasFeature(feature)) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
}